<template>
  <v-container fluid class="payroll-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/payroll/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn 
                v-show="itemSelected.length>0"
                :loading="isLoading"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
                @click="prepareData"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Get
              </v-btn>
              <!-- <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="itemSelected!=null"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="itemSelected"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="payrolls-table"
              show-select
              single-select
              item-key="_id"
              sort-by="payrollnum"
              :footer-props="footer"
              :headers="headers"
              :items="payrolls"
              :items-per-page="itemPerPage"
              >
              <template v-slot:top>
                <v-dialog
                  v-model="deleteDialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Payroll?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteItem.payrollname  }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="deleteDialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deletePayroll(deleteItem)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog
                  v-model="emailDialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Send Email for {{ emailItem.payrollname }} ?
                    </v-card-title>

                    <v-card-text>
                      This action will send email to all employees. After emails are sent, this action cannot be undone. 
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="emailDialog = false">Cancel</v-btn>
                      <v-btn color="success" class="button-shadow" @click="emailPayroll(emailItem)">Send</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.payrollstatus="{ item }">
                <v-chip
                  :color="item.payrollstatus=='New' ? 'primaryConst white--text' : item.payrollstatus=='Pending' ? 'warning white--text' : item.payrollstatus=='Complete' ? 'successConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.payrollstatus }}
                </v-chip>
              </template>
              <template v-slot:item.payrolldate="{ item }">
                {{ new Date(item.payrolldate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.payrollstartdate="{ item }">
                <p class='two-line'>{{ new Date(item.payrollstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                <p class='two-line'>{{ new Date(item.payrollenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
              </template>
              <template v-slot:item.isData="{ item }">
                {{ item.isData}}
              </template>
              <template v-slot:item.approval="{ item }">
                <div v-if="item.approval!=null && item.approval.approverid!=null">
                  <p class="two-line" style="margin-left: 5px;">
                    <v-avatar v-if="item.approval.approvalimage!=null" size="40">
                      <img v-bind:src="item.approval.approvalimage" alt="">
                    </v-avatar>
                  </p>
                <p class="two-line"><span style="margin-left:5px">{{ item.approval.approvalname }} </span></p>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.payrollstatus=='New'" icon color="primary" @click="updatePayrollPendingDialog(item)">
                    <v-icon>mdi-account-edit-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.payrollstatus=='Complete'" icon color="primary" @click="EmailDialog(item)">
                  <v-icon>mdi-email-send-outline</v-icon>
                </v-btn>
                <v-btn v-if="item.payrollstatus=='New'" icon color="primary" @click="DeleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                <download-excel
                  v-if="item.isData=='Yes'"
                  class="btn btn-default"
                  :data="item.data"
                  worksheet="My Worksheet"
                  type="xls"
                  :name="getFileName()"
                >
                  <v-btn 
                    v-show="item.data.length>0"
                    icon 
                    color="primary"
                  >
                  <v-icon>mdi-microsoft-excel</v-icon>
                  </v-btn>
                </download-excel>

              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isApproveSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send for Approval</span>
            </v-card-title>
            <v-card-text>
              {{ approve_send.payrollname }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="approve_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isApproveSend=false; approve_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="approve_send.confirm!=='Send'"
                @click="updatePayrollPending"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'payrollList',
  data() {
    return {
      itemSelected: [],
      deleteDialog: false,
      emailDialog: false,
      isApproveSend: false,
      deleteItem: {},
      emailItem: {},
      approve_send: {}, 
      headers: [
        { text: 'Name', value: 'payrollname' },
        { text: 'Date', value: 'payrolldate', width:'12%' },
        { text: 'Start|End', value: 'payrollstartdate', width:'12%' },
        { text: 'Approval', value: 'approval', width: '12%' },
        { text: 'Status', value: 'payrollstatus', width:'10%'  },
        { text: 'Actions', value: 'actions', sortable: false, width:'10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      list: [],
      isLoading: false,
    }
  },

  computed: {
    ...mapState('Payroll', ['payrolls', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating', 'currentEmployeeId']),
    ...mapState('Employee', ['employees']),
    ...mapState('Account', ['accounts']),
  },
  async created() {
    await this.getPayrollsRequest();
    console.log(this.payrolls)
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
  methods: {
    ...mapActions('Payroll', ["getPayrollsRequest","deletePayrollRequest","emailPayrollRequest","createPayrollRequest", "updatePayrollPendingRequest"]),
    ...mapActions('PayStatement', ['getPayStatementsByPayroll']),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('Account', ["getAccountsRequest"]),
    
    editItem(item) {
      this.$router.push({ name: 'PayrollEdit', params: item })
    },
    async prepareData(){
      this.isLoading = true;
      if(this.itemSelected==null  || this.itemSelected.length==0) return;
      let selected = this.itemSelected[0];
      let data = await this.copyMenuRequest(selected._id);
      console.log(data);
      this.isLoading = false;
      this.itemSelected = [];
    },
    getFileName(){
      var d = new Date();
      var name = 'payroll-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    async getPayStatements(id){
      let statements = await this.getPayStatementsByPayroll(id);
      let results = [];
      let fields = [];
      for(var x in statements) {
        let statement = statements[x];
        let employee = this.employees.find(employee=>employee._id==statement.employeeid);
        results.push({
          employeeid: employee['_id'], 
          employee_name: employee['employeename'], 
          pay_date: new Date(statement.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }),
        });
        let filter = statement.transactions.filter(x=>x.transsubtype=='Addition')
        for(var a in filter){
          let trans = filter[a];
          let result = results.find(x=>x.employeeid==trans.employeeid);
          let name = trans['transdesc'];
          let currency = trans['transcurrency'];
          let currency2 = trans['transcurrency2'];
          let field1 = name + ` (${currency})`
          let field2 = name + ` (${currency2})`
          if(!(fields.includes(field1))) fields.push({name: field1, rank: 1});
          if(!(fields.includes(field2))) fields.push({name: field2, rank: 1});

          if(field1 in result) result[field1] = result[field1] + parseFloat(trans.transcredit);
          else result[field1] = parseFloat(trans.transcredit); 

          if(field2 in result) result[field2] = result[field2] + parseFloat(trans.transcredit2);
          else result[field2] = parseFloat(trans.transcredit2);
        }
        filter = statement.transactions.filter(x=>x.transsubtype=='Deduction')
        for(var b in filter){
          let trans = filter[b];
          let result = results.find(x=>x.employeeid==trans.employeeid);
          let name = trans['transdesc'];
          let currency = trans['transcurrency'];
          let currency2 = trans['transcurrency2'];
          let field1 = name + ` (${currency})`
          let field2 = name + ` (${currency2})`
          if(!(fields.includes(field1))) fields.push({name: field1, rank: 2});
          if(!(fields.includes(field2))) fields.push({name: field2, rank: 2});
          if(field1 in result) result[field1] = result[field1] + parseFloat(trans.transdebit);
          else result[field1] = parseFloat(trans.transdebit); 

          if(field2 in result) result[field2] = result[field2] + parseFloat(trans.transdebit2);
          else result[field2] = parseFloat(trans.transdebit2); 
        }
        
        filter = statement.transactions.filter(x=>x.transsubtype=='Contribution')
        for(var c in filter){
          let trans = filter[c];
          let result = results.find(x=>x.employeeid==trans.employeeid);
          let name = trans['transdesc'];
          let currency = trans['transcurrency'];
          let currency2 = trans['transcurrency2'];
          let field1 = name + ` (${currency})`
          let field2 = name + ` (${currency2})`
          if(!(fields.includes(field1))) fields.push({name: field1, rank: 3});
          if(!(fields.includes(field2))) fields.push({name: field2, rank: 3});
          if(field1 in result) result[field1] = result[field1] + parseFloat(trans.transcredit);
          else result[field1] = parseFloat(trans.transcredit); 

          if(field2 in result) result[field2] = result[field2] + parseFloat(trans.transcredit2);
          else result[field2] = parseFloat(trans.transcredit2);
        }
      }
      for(var result of results){
        for(var field of fields) {
          if(!( field in result )) result[field] = null;
        }
      }

      console.log(fields);
      return results;      
    },
    async getJson(){
      console.log(this.itemSelected)
      let json = {
        ordernum: this.itemSelected, 
      };
      return [json];
    },
    deletePayroll(item) {
      this.deletePayrollRequest({_id: item._id});
      this.deleteDialog = false;
    },
    async emailPayroll(item) {
      await this.emailPayrollRequest({_id: item._id});
      this.emailDialog = false;
    },
    printItem(item) {
      this.$router.push({ name: 'PayrollPrint', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'PayrollView', params: item })
    },
    DeleteDialog(item) {
      this.deleteDialog = true;
      this.deleteItem = {
        _id: item._id,
        payrollname: item.payrollname,      
      }
    },
    EmailDialog(item) {
      this.emailDialog = true;
      this.emailItem = {
        _id: item._id,
        payrollname: item.payrollname,      
      }
    },
    updatePayrollPendingDialog(item) {
      this.isApproveSend = true;
      this.approve_send = {
        _id: item._id,
        payrollnum: item.payrollnum,
        payrollname: item.payrollname,
      };
    },
    async updatePayrollPending() {
      this.isApproveSend = false;
      let result = await this.updatePayrollPendingRequest(this.approve_send);
      console.log(result)
      //let index = this.data_payments.findIndex((x) => x._id == result._id);
      //this.data_payments.splice(index, 1, result);
      this.approve_send = {};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
